import { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import { AuthContext } from "../../context/Auth/AuthContext";

// As importacoes (listas, planilha de contatos e agenda do celular) rodam em
// segundo plano no backend; o progresso sai em canais escopados que so a tela
// de origem escuta. Este listener vive no layout logado e escuta o canal geral
// `company-{companyId}-importacao`, que carrega apenas a conclusao (ou o erro):
// e ele que faz o aviso alcancar o usuario em qualquer tela, com toast clicavel
// e notificacao desktop para quem esta em outra aba. A permissao de Notification
// ja e pedida pelo NotificationsPopOver na entrada do layout.
//
// O `tipo` do payload distingue a origem: ausente = lista de contatos
// (campanhas), "planilha-contatos" e "agenda" = cadastro geral (/contacts).

const descreveImportacao = data => {
  if (data.tipo === "agenda") {
    return {
      titulo: "Importacao da agenda concluida",
      resumo: `${data.criados} novo(s), ${data.atualizados} atualizado(s), ${data.falhas} falha(s)`,
      destino: "/contacts",
      tag: "importacao-agenda"
    };
  }

  if (data.tipo === "planilha-contatos") {
    return {
      titulo: "Importacao de contatos concluida",
      resumo: `${data.criados} novo(s), ${data.ignorados} ja existia(m), ${data.invalidos} invalido(s)`,
      destino: "/contacts",
      tag: "importacao-contatos"
    };
  }

  const nome = data.listaNome ? `"${data.listaNome}"` : `#${data.listaId}`;
  return {
    titulo: `Importacao concluida — lista ${nome}`,
    resumo: `${data.criados} novo(s), ${data.ignorados} ja existia(m), ${data.invalidos} invalido(s)`,
    destino: `/contact-lists/${data.listaId}/contacts`,
    tag: `importacao-${data.listaId}`
  };
};

const ImportacaoNotificacao = () => {
  const history = useHistory();
  const { user, socket } = useContext(AuthContext);

  useEffect(() => {
    if (!user?.companyId || !socket) return undefined;

    const canal = `company-${user.companyId}-importacao`;

    const navegaPara = destino => {
      window.focus();
      history.push(destino);
    };

    const onImportacao = data => {
      if (data.action === "import-finish") {
        const aviso = descreveImportacao(data);

        toast.success(`${aviso.titulo}: ${aviso.resumo}. Clique para abrir.`, {
          autoClose: 10000,
          onClick: () => navegaPara(aviso.destino)
        });

        if ("Notification" in window && Notification.permission === "granted") {
          const notificacao = new Notification(aviso.titulo, {
            body: `${aviso.resumo}.`,
            tag: aviso.tag,
            renotify: true
          });
          notificacao.onclick = e => {
            e.preventDefault();
            navegaPara(aviso.destino);
          };
        }
      }

      if (data.action === "import-cancel") {
        // Cancelamento pedido pelo usuario: os contatos gravados ate ali
        // ficaram, entao o aviso traz os parciais. `tipo` distingue a origem,
        // como no import-finish.
        const ehCadastroGeral = data.tipo === "planilha-contatos";
        const alvo = ehCadastroGeral
          ? "de contatos"
          : `da lista ${data.listaNome ? `"${data.listaNome}"` : `#${data.listaId}`}`;
        const destino = ehCadastroGeral
          ? "/contacts"
          : `/contact-lists/${data.listaId}/contacts`;

        toast.info(
          `Importacao ${alvo} cancelada: ${data.criados} novo(s) ja gravados, ${data.ignorados} ja existia(m), ${data.invalidos} invalido(s). Clique para abrir.`,
          {
            autoClose: 10000,
            onClick: () => navegaPara(destino)
          }
        );
      }

      if (data.action === "import-error") {
        const destino = data.tipo
          ? "/contacts"
          : `/contact-lists/${data.listaId}/contacts`;

        toast.error(data.mensagem, {
          onClick: () => navegaPara(destino)
        });
      }
    };

    socket.on(canal, onImportacao);
    return () => socket.off(canal, onImportacao);
  }, [user?.companyId, socket, history]);

  return null;
};

export default ImportacaoNotificacao;
